export default __webpack_public_path__ + "static/media/comics.4e22c8e8.png";